// extracted by mini-css-extract-plugin
export default {"overlay":"VideoModal_overlay__4fNKu","modal":"VideoModal_modal__WSV9I","videoFrame":"VideoModal_videoFrame__NaIRJ"};